// src/pages/RankingPage.js
// eslint-disable-next-line no-unused-vars
import React, {useState} from 'react';
import styled from 'styled-components';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';
import PlayerRanking from '../components/ui/ranking/playerRanking';
import PlayerKillRanking from '../components/ui/ranking/playerKillRanking';
import MonsterKillRanking from '../components/ui/ranking/monsterKillRanking';
import GuildRanking from '../components/ui/ranking/guildRanking';
import {useTranslation} from 'react-i18next';

const RankingPage = () => {
  const {t} = useTranslation();
  const [selectedRanking, setSelectedRanking] = useState('player');

  const rankingSections = {
    player: t('ranking.sections.player'),
    playerKill: t('ranking.sections.playerKill'),
    monster: t('ranking.sections.monster'),
    guild: t('ranking.sections.guild'),
  };

  let content;
  switch (selectedRanking) {
    case 'player':
      content = <PlayerRanking />;
      break;
    case 'playerKill':
      content = <PlayerKillRanking />;
      break;
    case 'monster':
      content = <MonsterKillRanking />;
      break;
    case 'guild':
      content = <GuildRanking />;
      break;
    default:
      content = <div>Please select a ranking section.</div>;
  }

  return (
    <PageContentComponent>
      <PageContainerTitleComponent title="Ranking" />
      <ContentWrapper>
        <ButtonContainer>
          {Object.entries(rankingSections).map(([key, label]) => (
            <SectionButton key={key} onClick={() => setSelectedRanking(key)} active={selectedRanking === key}>
              {label}
            </SectionButton>
          ))}
        </ButtonContainer>
        <ContentContainer>{content}</ContentContainer>
      </ContentWrapper>
    </PageContentComponent>
  );
};

const ContentWrapper = styled.div`
  min-height: 2000px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
`;

const SectionButton = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  color: ${({active}) => (active ? '#000' : '#fff')};
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

const ContentContainer = styled.div`
  margin-top: 20px;
  padding: 20px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export default RankingPage;
